import { getApiUrl } from "utils/getApiUrl";

import { CreateStripeSession } from "../models";

/**
 * Get a Stripe checkout URL that redirects the user to the Stripe hosted page.
 *
 * @param accessToken
 * @param session
 * @returns
 */
export async function getCheckoutUrl(accessToken: string, session: CreateStripeSession): Promise<string> {

    const api = getApiUrl();

    const url: string = await fetch(`${api}/stripe/checkout`, {
        method: "POST",
        headers: {
            "x-xapp-usertoken": accessToken,
            "content-type": "application/json"
        },
        body: JSON.stringify(session)
    }).then((res) => {
        return res.json();
    }).then((json) => {
        if (json.httpStatus === 200) {
            return json.url;
        } else {
            throw new Error(json.message);
        }
    });

    return url;
}